




















import { defineComponent } from '@nuxtjs/composition-api'
import { useI18n } from '~/composables/i18n'

export default defineComponent({
  props: {
    productId: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n()

    return {
      t,
    }
  },
})
